export default __webpack_public_path__ + "static/blog-5ffa8869f8c8331360ab50e5125b91d5.webp";